'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index = require('../../../../../../_virtual/index.cjs');
var React = require('react');
require('@emotion/react');
require('../../../utils/AviaryProvider/AviaryThemeContext.cjs');
require('../../../../../../_virtual/index2.cjs');
require('aviary-tokens');
var useInputFocus = require('../../../utils/hooks/useInputFocus.cjs');
var useSanitizeInputErrors = require('../../../utils/hooks/useSanitizeInputErrors.cjs');
var InternalInputCaption_web = require('./InternalInputCaption/InternalInputCaption.web.cjs');
var InternalTextInput_web_styles = require('./InternalTextInput.web.styles.cjs');

/**
 * An internal component that is used for all string input types
 *
 * @scope Internal
 */ const InternalTextInput = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { value, id, label, onBlur, customWrapperStyles, customInputStyles, required, disabled, placeholder, inputCaption, errorCaption, rightContent, leftContent, readOnly = false, hideLabel = false, size = "large", ...rest } = props;
    React.useImperativeHandle(ref, ()=>textInputRef.current);
    const { isFocused, isDirty, isKeyboardFocused, handleFocus, handleBlur, textInputRef } = useInputFocus.useInputFocus(onBlur);
    const { validationError } = index.cjsExports.useInputValidation({
        isDirty,
        required,
        value: String(value),
        label
    });
    const { hasError } = useSanitizeInputErrors.useSanitizeInputErrors(errorCaption, validationError);
    const isLabelFloating = value !== null && value !== undefined && value !== "" || placeholder;
    const containerStyles = [
        InternalTextInput_web_styles.container.base,
        readOnly && InternalTextInput_web_styles.container.readOnly,
        disabled && InternalTextInput_web_styles.container.disabled,
        customWrapperStyles
    ];
    const inputStyles = [
        InternalTextInput_web_styles.htmlInput.base,
        hideLabel && size === "medium" && InternalTextInput_web_styles.mediumSize,
        rightContent && InternalTextInput_web_styles.htmlInput.withRightContent,
        leftContent && InternalTextInput_web_styles.htmlInput.withLeftContent,
        (isLabelFloating || isFocused) && !hideLabel && InternalTextInput_web_styles.htmlInput.withFloatingLabel,
        hasError && !disabled && !isFocused && !readOnly && InternalTextInput_web_styles.htmlInput.error,
        customInputStyles
    ];
    const labelStyles = [
        InternalTextInput_web_styles.label.base,
        (isLabelFloating || isFocused) && InternalTextInput_web_styles.label.floating,
        hasError && !isFocused && !disabled && !readOnly && value && InternalTextInput_web_styles.label.error,
        leftContent && InternalTextInput_web_styles.label.withLeftContent
    ];
    const renderInput = ()=>{
        return /*#__PURE__*/ jsxRuntime.jsx("input", {
            id: id,
            ref: textInputRef,
            value: value,
            onBlur: handleBlur,
            onFocus: handleFocus,
            required: required,
            "aria-errormessage": hasError && !disabled ? `${id}-error` : undefined,
            css: inputStyles,
            "aria-invalid": hasError,
            placeholder: placeholder,
            disabled: disabled,
            readOnly: readOnly,
            "aria-label": label,
            "aria-readonly": readOnly,
            ...rest
        });
    };
    const renderInputInfo = ()=>{
        if (readOnly || disabled && hasError || hasError && isFocused) return;
        return /*#__PURE__*/ jsxRuntime.jsx(InternalInputCaption_web.InternalInputCaption, {
            id: id,
            inputCaption: inputCaption,
            errorCaption: [
                errorCaption,
                validationError
            ]
        });
    };
    const renderRequiredAsterisk = ()=>{
        if (required) {
            return /*#__PURE__*/ jsxRuntime.jsx("span", {
                "aria-hidden": true,
                css: InternalTextInput_web_styles.requiredAsterisk,
                "data-testid": "required-asterisk",
                children: "*"
            });
        }
    };
    return /*#__PURE__*/ jsxRuntime.jsxs("div", {
        css: containerStyles,
        children: [
            /*#__PURE__*/ jsxRuntime.jsxs("div", {
                css: [
                    InternalTextInput_web_styles.floatingLabelWrapper,
                    isKeyboardFocused && InternalTextInput_web_styles.focusRing
                ],
                children: [
                    leftContent && /*#__PURE__*/ jsxRuntime.jsx("div", {
                        css: InternalTextInput_web_styles.leftContent,
                        children: leftContent
                    }),
                    /*#__PURE__*/ jsxRuntime.jsxs("label", {
                        htmlFor: id,
                        css: hideLabel ? InternalTextInput_web_styles.label.hidden : labelStyles,
                        children: [
                            readOnly ? `${label} (read-only)` : label,
                            renderRequiredAsterisk()
                        ]
                    }),
                    renderInput(),
                    rightContent && /*#__PURE__*/ jsxRuntime.jsx("div", {
                        css: InternalTextInput_web_styles.rightContent,
                        children: rightContent
                    })
                ]
            }),
            renderInputInfo()
        ]
    });
});

exports.InternalTextInput = InternalTextInput;
//# sourceMappingURL=InternalTextInput.web.cjs.map
